import { CommonModule } from '@angular/common';
import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';
import * as i0 from "@angular/core";
export class ConfirmModalModule {
}
ConfirmModalModule.ɵfac = function ConfirmModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ConfirmModalModule)(); };
ConfirmModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ConfirmModalModule });
ConfirmModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, ModalBaseModule] });
